export const WITHDRAWAL_STATUS = {
  0: "Solicitado",
  1: "Completado",
  2: "Error",
  3: "Rechazado",
  4: "En proceso",
  5: "Expirado",
};